import { makeRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkUploadAttachment, FilesDelete } = Endpoints;
const { errors: errorsCopies, success: successCopies } = strings.bulkEmails;

/**
 * @param {FormData} attachmentFormData
 * @returns {Promise<OperationResult>}
 */
export const uploadTemporaryAttachment = async attachmentFormData =>
  makeRequest({
    url: BulkUploadAttachment,
    data: attachmentFormData,
    method: 'post',
    alertConfig: {
      error: {
        title: errorsCopies.uploadTemporaryAttachments.title
      }
    }
  });

/**
 * @param {number} id
 * @returns {Promise<OperationResult>}
 */
export const deleteTemporaryAttachment = async id =>
  makeRequest({
    endpointOptions: {
      path: FilesDelete,
      replaceId: id
    },
    method: 'delete',
    alertConfig: {
      success: {
        title: successCopies.deleteTemporaryAttachments.title,
        body: ({ message }) => message
      },
      error: {
        title: errorsCopies.deleteTemporaryAttachments.title
      }
    }
  });
